import {
  CloseOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Button, Space, Typography } from "antd";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import Modal from "@/components/Elements/Modal/Modal";
import { useUpdateProject } from "@/entities/project";
import { TranslateCost } from "@/modules/translate";
import { useThemeBreakpoints } from "@/services/theme";

import AdditionalCostsForm from "./AdditionalCostsForm";

import "./AdditionalCosts.style.less";

const { Text } = Typography;

const AdditionalCosts = ({ project }) => {
  const { t } = useTranslation();
  const { xl } = useThemeBreakpoints();
  const [visible, setVisible] = useState(false);
  const [cumulatedAdditionalCosts, setCumulatedAdditionalCosts] = useState(0);

  const mutation = useUpdateProject(project.id);

  const hasAdditionalCosts = project.additional_costs.length > 0;

  const initialValues = project.additional_costs.map(
    ({ type, estimated_cost, precision, source, description }) => {
      return {
        type,
        estimated_cost,
        precision,
        source,
        description,
      };
    }
  );

  const handleCancel = () => {
    setVisible(false);
  };

  const modalWidth = xl ? "70vw" : "90%";

  return (
    <>
      <Button
        size="small"
        icon={hasAdditionalCosts ? <EditOutlined /> : <PlusOutlined />}
        onClick={() => setVisible(true)}
      >
        {hasAdditionalCosts
          ? t("project:costsCard.editAdditionalCosts")
          : t("project:costsCard.addAdditionalCosts")}
      </Button>
      <Modal
        title={t("project:additionalCosts.details")}
        className="additional-costs-modal"
        width={modalWidth}
        style={{ maxWidth: "1200px" }}
        open={visible}
        onCancel={handleCancel}
        destroyOnHidden
        mask={{ closable: false }}
        footer={[
          <Space
            key="cumulated-additional-cost"
            className="cumulated-additional-cost"
          >
            <span>{t("project:additionalCosts.cumulatedAdditionalCosts")}</span>
            <Text className="cost" data-testid="cumulated_additional_costs">
              <TranslateCost value={cumulatedAdditionalCosts} />
            </Text>
          </Space>,
          <Space key="buttons-space">
            <Button
              key="cancel"
              icon={<CloseOutlined />}
              onClick={handleCancel}
              style={{ marginRight: 10 }}
            >
              {t("global:cancel")}
            </Button>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              form="additionalCostsForm"
              key="submit"
              htmlType="submit"
              loading={mutation.isPending}
            >
              {t("global:save")}
            </Button>
          </Space>,
        ]}
      >
        <AdditionalCostsForm
          mutation={mutation}
          initialValues={initialValues}
          onSuccess={() => setVisible(false)}
          onTotalChange={setCumulatedAdditionalCosts}
        />
      </Modal>
    </>
  );
};

AdditionalCosts.propTypes = {
  project: PropTypes.object,
};

export default AdditionalCosts;
